export default "__VITE_ASSET__fkr0rNNC__"